export const PartnerStatus = {
  Draft: 'Draft',
  Invited: 'Invited',
  Onboarding: 'Onboarding',
  Active: 'Active',
  Lost: 'Lost',
  Inactive: 'Inactive',
} as const;

export type PartnerStatus = (typeof PartnerStatus)[keyof typeof PartnerStatus];

const ALLOWED_LOGIN_STATUSES = [
  PartnerStatus.Invited,
  PartnerStatus.Onboarding,
  PartnerStatus.Active,
] as PartnerStatus[];

const ONBOARDING_STATUSES = [PartnerStatus.Invited, PartnerStatus.Onboarding] as PartnerStatus[];

const DIRECT_LOGIN_ALLOWED_STATUSES = [
  PartnerStatus.Invited,
  PartnerStatus.Onboarding,
  PartnerStatus.Active,
] as PartnerStatus[];

class Partner {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly status: PartnerStatus
  ) {}

  get isAccessAllowed(): boolean {
    return ALLOWED_LOGIN_STATUSES.includes(this.status);
  }

  get isInOnboarding(): boolean {
    return ONBOARDING_STATUSES.includes(this.status);
  }

  get isDirectLoginAllowed(): boolean {
    return DIRECT_LOGIN_ALLOWED_STATUSES.includes(this.status);
  }
}

export default Partner;
